import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
// import { createBrowserHistory } from "history";
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';

import Store from "./store"
import AppHeader from "./components/Header";
import AppFooter from "./components/Footer";
import Home from './components/Home';
import ProductDetail from "./components/ProductDetail"
import Contact from "./components/Contact"
import About from "./components/About"
import Service from "./components/Service"
import Product from './components/Product';
import NotFoundRoute from "./components/NotFoundRoute"
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  return (
     <Provider store={Store}>
        <BrowserRouter>
        <Helmet>
          <title>Kalinga Testing Instruments Pvt Ltd | Manufacturer and Distributor of Lab Instruments</title>
          <meta
            name="description"
            content="Kalinga Testing Instruments Pvt Ltd is committed to provide quality instruments and services at competitive pricing, to meet individual customer needs within the scientific and engineering communities."
          />
          <meta
            name="keywords"
            content="Kalinga Testing Instruments Pvt Ltd, DeFelsko Inspection Instruments in India, Kalinga Testing Instruments, defelsko Authorized Distributors, Wagner Meters Authorized Distributors, Delmhorst Authorized Distributors, Delmhorst Moisture Meter Distributor, Defelsko PosiTector Distributor, Calibration Service"
          />
        </Helmet>
          <AppHeader />
          <Routes>
            <Route path="/product/detail/:slug" element={<ProductDetail />} />
            <Route exact path="/products" element={<Product />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Service />} />
            <Route path="/about" element={<About />} />
            <Route exact path="/" element={<Home />} />
            <Route path="/privacy-policy"  element={<PrivacyPolicy />} />
            <Route element={<NotFoundRoute />} />
          </Routes>
          <AppFooter />
        </BrowserRouter>
    </Provider>
  );
}

export default App;
